import cn from "classnames";
import { Transition } from "components/shared/column";
import { Checkbox, Datetime, Field, FileField, Flags, GeoPicker, Select } from "components/shared/form";
import Loader from "components/shared/loader";
import ScrollPositionContext from "contexts/scrollPosition";
import { renderRelatedFields, serializeReq, validateForm } from "helpers/form";
import React, { Component } from "react";
import { Scrollbars } from "react-custom-scrollbars-2";

export default class BookShow extends Component {
    static contextType = ScrollPositionContext;

    state = {
        isLoading: true,
        isValid: true,
        openedDropd: false,
        shouldUpdate: false,
        data: {},
        initial: {},
    };

    get dropdActions() {
        const actions = [{ text: "Печать", action: this.actionPrint }];
        if (!this.props.canEditBooks) {
            return actions;
        }
        actions.push({ text: "Удалить", action: this.actionClose });
        return actions;
    }

    componentDidMount() {
        this.context?.setPrevItemId(Number(this.props.match.params.id));
        const initial = this.props.initialState;
        this.setState({ data: initial, initial });
        this.getItem(this.props);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        const { params } = nextProps.match;
        if (params.id !== this.props.match.params.id) {
            this.setState({ isLoading: true });
            this.getItem(nextProps);
        }
    }

    getItem = ({ source, match }) => {
        const defParams = { isLoading: false, isValid: true, shouldUpdate: false };
        source.getItem(match.params).then((data) => this.setState({ data, initial: data, ...defParams }));
    };

    update = (callback) => {
        if (callback) {
            callback();
        }
        this.getItem(this.props);
    };

    isValidForm = (state) => {
        const config = this.getValidationConfig(state);
        return validateForm(config, serializeReq(state, config));
    };

    getValidationConfig = () => this.props.config;

    getRequestData = (data) => data;

    apply = () => {
        const { source, match, mergeParams, config } = this.props;
        const { isLoading, shouldUpdate, ...state } = this.state;
        if (!isLoading && shouldUpdate) {
            if (this.isValidForm(state.data)) {
                this.setState({ isLoading: true, isValid: true });
                return source
                    .apply(serializeReq({ id: match.params, ...this.getRequestData(state.data) }, config))
                    .then((res) =>
                        res ? this.update(mergeParams) : this.setState({ isLoading: false, isValid: false }),
                    );
            }
            this.setState({ isValid: false });
        }
    };

    setValue = ({ value, name }) => {
        const { data, initial } = this.state;
        const nextData = { ...data, [name]: value };
        let shouldUpdate = false;
        for (const key in data) {
            if (initial[key] !== nextData[key]) {
                shouldUpdate = true;
                break;
            }
        }
        const isValid = this.isValidForm(nextData);
        this.setState({ data: nextData, shouldUpdate, ...(isValid ? { isValid: true } : {}) });
    };

    isFieldEditable = () => this.props.canEditBooks;

    isFieldDisabled = (name, props = {}) => {
        if (props.disabled !== undefined) {
            return props.disabled;
        }
        return !this.isFieldEditable(name) && !props.alwaysEnabled;
    };

    renderButton = () => {
        if (!this.props.canEditBooks) {
            return null;
        }
        const cname = cn("btn btn-brand btn-sm", { disabled: !this.state.shouldUpdate });
        return (
            <div className="panel__row panel__row--button">
                <div className={cname} onClick={this.apply}>
                    Обновить
                </div>
            </div>
        );
    };

    actionClose = () => {
        const { modal, source, mergeParams, back } = this.props;
        return modal({
            name: "confirm",
            title: "Удаление",
            text: "Вы действительно хотите удалить элемент?",
            onSuccessAction: () => {
                back();
                mergeParams?.();
            },
            action: () => source.delItem({ id: this.state.data.id }),
        });
    };

    actionPrint = () => {
        return null;
    };

    renderDropd = () => {
        const { openedDropd } = this.state;
        return (
            openedDropd && (
                <ul className="c-dropd__list c-dropd__list--wide no-bullet">
                    {this.dropdActions.map((item, i) => (
                        <li key={i} className="c-dropd__list-item" onClick={item.action}>
                            {item.text}
                        </li>
                    ))}
                </ul>
            )
        );
    };

    openDropd = () => {
        this.setState({ openedDropd: true });
        setTimeout(() => document.addEventListener("click", this.closeDropd), 0);
    };

    closeDropd = () => {
        this.setState({ openedDropd: false });
        document.removeEventListener("click", this.closeDropd);
    };

    renderHead = () => {
        const { back, title } = this.props;
        return (
            <div className="book-show__head">
                <div className="book-show__close close close--sm" onClick={back} />
                <div className="book-show__title">{title}</div>
                {!!this.dropdActions.length && (
                    <div className="book-show__dropdown c-dropd">
                        <div className="c-dropd__btn" onClick={this.openDropd} />
                        {this.renderDropd()}
                    </div>
                )}
            </div>
        );
    };

    renderGeopicker = (props) => {
        const switchMap = () => {
            this.props.addModal({
                name: "simpleMapPicker",
                title: "Выбрать адрес",
                windowMod: "wide modal--vh-75",
                value: this.state.data[props.inputProps.name],
                callback: (value) => {
                    if (value && Object.keys(value).length) {
                        this.setValue({ name: props.inputProps.name, value });
                    }
                },
            });
        };

        return (
            <GeoPicker
                key={props.label}
                label={props.label}
                name={props.inputProps.name}
                switchMap={switchMap}
                onChange={this.setValue}
                value={this.state.data[props.inputProps.name]}
                {...props}
            />
        );
    };

    renderField = ({ inputProps, ...props }) => {
        const disabled = this.isFieldDisabled(inputProps.name, props);
        return (
            <Field
                key={props.label}
                wrapper="panel__row"
                onChange={this.setValue}
                value={this.state.data[inputProps.name]}
                inputProps={{ ...inputProps, disabled }}
                {...props}
            />
        );
    };

    renderFileField = ({ inputProps, ...props }) => {
        if (inputProps.disabled) {
            delete inputProps.disabled;
        }
        return (
            <FileField
                key={props.label}
                wrapper="panel__row"
                onChange={this.setValue}
                value={this.state.data[inputProps.name]}
                inputProps={{ ...inputProps, disabled: !this.props.canEditBooks && !props.alwaysEnabled }}
                {...props}
            />
        );
    };

    renderFlags = ({ inputProps, ...props }) => {
        if (!inputProps) {
            return null;
        }
        if (inputProps.disabled) {
            delete inputProps.disabled;
        }
        return (
            <Flags
                key={props.label}
                onChange={this.setValue}
                value={this.state.data[inputProps.name]}
                inputProps={{ ...inputProps, disabled: !this.props.canEditBooks && !props.alwaysEnabled }}
                {...props}
            />
        );
    };

    renderCheckbox = ({ inputProps, ...props }) => {
        const disabled = this.isFieldDisabled(inputProps.name, props);
        return (
            <Checkbox
                key={props.label}
                wrapper="panel__row"
                onChange={this.setValue}
                value={this.state.data[inputProps.name]}
                {...props}
                disabled={disabled}
                inputProps={{ ...inputProps, disabled }}
            />
        );
    };

    renderDateField = ({ inputProps, ...props }) => {
        const dateProps = this.getDateFieldProps(props);
        const disabled = this.isFieldDisabled(inputProps.name, dateProps);
        return (
            <Datetime
                key={dateProps.label}
                onChange={this.setValue}
                value={this.state.data[inputProps.name]}
                inputProps={{ ...inputProps, disabled }}
                {...dateProps}
            />
        );
    };

    getDateFieldProps = (props) => props;

    renderSelect = ({ inputProps, ...props }) => {
        const disabled = this.isFieldDisabled(inputProps.name, props);
        const defProps = {
            key: props.label,
            wrapper: "panel__row",
            onChange: this.setValue,
            value: this.state.data[inputProps.name],
        };
        props.dictionary && (props.options = this.props.enums[props.dictionary] || []);
        if (props.relatedFields) {
            const fieldsData = {
                defProps,
                props: {
                    ...props,
                    inputProps: { ...inputProps, disabled },
                },
                renderSelect: this.renderSelect,
                renderField: this.renderField,
            };
            return renderRelatedFields(fieldsData);
        }
        const { key, ...selectProps } = {
            ...defProps,
            inputProps: { ...inputProps, disabled },
            ...props,
        };
        return <Select {...selectProps} key={key} />;
    };

    renderBody = () => {
        return null;
    };

    renderBodyWrap = () => {
        const { isLoading } = this.state;
        const { nativeScroll } = this.props;
        if (isLoading) {
            return <Loader prefix="absolute-center" />;
        }
        return nativeScroll ? (
            <div className="overflow-auto h-100 native-scroll__wrap">
                <div className="native-scroll__container h-100">{this.renderBody()}</div>
            </div>
        ) : (
            <div className="native-scroll__wrap h-100">
                <Scrollbars>
                    <div className="native-scroll__container">{this.renderBody()}</div>
                </Scrollbars>
            </div>
        );
    };

    render() {
        const { match, location, history, transition } = this.props;
        const cname = cn("book-show__body", { "book-show__body--invalid": !this.state.isValid });
        return (
            <Transition dir={transition || "left"} {...{ match, location, history }}>
                <div className="page-book__show book-show">
                    {this.renderHead()}
                    <div className={cname}>{this.renderBodyWrap()}</div>
                </div>
            </Transition>
        );
    }
}
